export const KZ_REGION_ID = '40';
